import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { User } from 'src/app/models/auth/user';
@Injectable({ providedIn: 'root' })

export class DataPersistenceService {
    tabInserted$: Subject<any> = new Subject();
    tabInserted: any = [];
    confirmationPopupStatus: Subject<any> = new Subject();
    
    updateTabInserted(dynamicTabs){
        this.tabInserted = dynamicTabs;
    }
    
    getTabInserted(){
        return this.tabInserted;
    }
    updateConfirmationPopupStatus(status){
        this.confirmationPopupStatus.next(status);
    }
}